/* eslint-disable */
import { store } from '../../store'
// import { httpgst, http } from '../../main'
import { httpgst } from '../../main'
import router from '../../router'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  async sendValidation({ commit }, { expensesRequest, ctx }) {
    try {
      const url = `api/travel-expenses-request/extension/${expensesRequest}`
      const options = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token
      const response = await httpgst.put(url, payload, options)
    } catch (error) {
      console.log(error)
    }
  },
  async changeStatusExtension({ commit }, { event }) {
    try {
      event.context.loadingChangeStatusExtension = true
      const extension = event.extension
      const payload = event.payload

      const url = `api/travel-expenses-request/extension/change-status/${extension}`
      const options = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token

      const response = await httpgst.put(url, payload, options)
      event.context.editedItem.extensions[payload.index].status = payload.status
      event.context.showNotification(response.data.message, 'success', -1)
      event.context.close()
      event.context.refresh()
    } catch (error) {
      console.log(error.response)
      event.context.showNotification(error.response.data.message, 'error', -1)
    } finally {
      event.context.loadingChangeStatusExtension = false
    }
  },
  async saveExtensions({ commit }, { event }) {
    try {
      event.context.loadingSaveExtensions = true
      const expensesRequest = event.context.editedItem.id
      const payload = event.context.editedItem.extensions[0]
      const url = `api/travel-expenses-request/extension/${expensesRequest}`
      const options = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token

      const response = await httpgst.put(url, payload, options)
      const folio = response.data.data.folio
      const status = response.data.data.status
      event.context.editedItem.extensions[0].folio = folio
      event.context.editedItem.extensions[0].status = status

      event.context.showNotification(response.data.message, 'success', -1)
      event.context.close()
      event.context.refresh()
      // event.context.init()
    } catch (error) {
      console.log(error)
      event.context.showNotification(error.response.data.message, 'error', -1)
    } finally {
      event.context.loadingSaveExtensions = false
    }
  },
  async saveExtensionsRequest({ commit }, { event }) {
    try {
      event.context.loadingSaveExtensions = true
      const expensesRequest = event.context.editedItemRequest.id
      const payload = event.context.editedItemRequest.extensions[0]
      const url = `api/travel-expenses-request/extension/${expensesRequest}`
      const options = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token

      const response = await httpgst.put(url, payload, options)
      const folio = response.data.data.folio
      const status = response.data.data.status
      event.context.editedItemRequest.extensions[0].folio = folio
      event.context.editedItemRequest.extensions[0].status = status

      event.context.close()
      event.context.refresh()
      event.context.showNotification(response.data.message, 'success', -1)
      // event.context.init()
    } catch (error) {
      console.log(error)
      event.context.showNotification(error.response.data.message, 'error', -1)
    } finally {
      event.context.loadingSaveExtensions = false
    }
  },
  async getVehicles({ commit }, { event }) {
    try {
      const url = 'api/vehicle'
      const options = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token

      const response = await httpgst.get(url, {}, options)
      event.context.vehicles = response.data.data
    } catch (error) {
      console.log(error)
    }
  },
  get({ commit, dispatch }, payload) {
    let url = 'api/travel-expenses-request/by-status'
    let params = {
      status: payload.event.context.statusTag
        ? payload.event.context.statusTag
        : undefined
    }
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params }, options).then(
      response => {
        commit('onGet', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getViaticsApproved({ commit, dispatch }, payload) {
    let url = 'api/travel-expenses-request/by-user'
    let params = {
      user_id: payload.event.user_id,
      status: payload.event.status
    }
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params }, options).then(
      response => {
        commit('onGet', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  downloadRequest({ commit, dispatch }, payload) {
    const type = payload.event.type
    let url = `api/travel-expenses-request/to-${type}/` + payload.event.item.id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': `application/${type}`
      }
    }
    let params = {
      responseType: 'blob'
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, params, options).then(
      response => {
        commit('onDownloadRequest', {
          event: payload.event,
          response: response,
          type
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getByValidator({ commit, dispatch }, payload) {
    let url = 'api/travel-expenses-request/by-validator'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGet', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getFiltered({ commit, dispatch }, payload) {
    let url = 'api/expenses/by-user/' + store.state.userLogged.id
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetFiltered', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getExpensesOpen({ commit, dispatch }, payload) {
    let url = 'api/expenses-open'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetExpensesOpen', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getById({ commit, dispatch }, payload) {
    let url = 'api/expenses/' + payload.event.expense_id
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetById', { event: payload.event, response: response })
      },
      error => {
        commit('onErrorById', { event: payload.event, error: error })
      }
    )
  },
  PostFileByExpensesRequest({ commit, dispatch }, payload) {
    let url = `api/travel-expenses-request/${payload.event.idExpenseRequest}/attachment`
    let params = {
      attach_file: payload.event.filesId,
    }

    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {}).then(
      response => {
        commit('onRefresh', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  post({ commit, dispatch }, payload) {
    let url = 'api/travel-expenses-request'
    let params = {
      project_id: payload.event.item.project_id,
      order_number: payload.event.item.order_number,
      gst_travel_type_id: payload.event.item.is_travel
        ? payload.event.item.travel_type.id
        : undefined,
      description: payload.event.item.description,
      creation_date: payload.event.item.creation_date,
      start_date: payload.event.item.start_date,
      end_date: payload.event.item.end_date,
      origin: payload.event.item.is_travel
        ? payload.event.item.origin
        : undefined,
      destination: payload.event.item.is_travel
        ? payload.event.item.destination
        : undefined,
      status: payload.event.item.status,
      // advance: payload.event.item.has_advance,
      advance: payload.event.item.totalAmount,
      // advance: payload.event.item.advance,
      is_petty_cash: payload.event.item.is_petty_cash,
      amount_advance: payload.event.item.totalAmount,
      // amount_advance: payload.event.item.amount_advance,
      assigned_user_id: payload.event.item.assigned_user_id
        ? payload.event.item.assigned_user_id
        : undefined,
      categories: JSON.parse(JSON.stringify(payload.event.item.categories)),
      validators: JSON.parse(JSON.stringify(payload.event.item.validators)),
      fuelRequests: payload.event.item.is_vehicle
        ? payload.event.item.fuelRequests
        : []
    }

    if (params.fuelRequests.length > 0 && !params.fuelRequests[0].description) {
      delete params.fuelRequests[0].description
    }

    if (payload.event.item.has_advance === 'caja_chica') {
      params.is_petty_cash = 1
      params.advance = false
      params.amount_advance = 0
    }

    if (payload.event.item.has_advance === 'anticipo') {
      params.is_petty_cash = 0
      params.advance = true
    }

    if (payload.event.item.has_advance === 'reembolso') {
      params.is_petty_cash = 0
      params.advance = false
      params.amount_advance = 0
    }

    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {}).then(
      response => {
        commit('onPost', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  put({ commit, dispatch }, payload) {
    let url = 'api/travel-expenses-request/' + payload.event.item.id
    let params = {
      project_id: payload.event.item.project_id,
      order_number: payload.event.item.order_number,
      gst_travel_type_id: payload.event.item.is_travel
        ? payload.event.item.travel_type.id
        : undefined,
      description: payload.event.item.description,
      creation_date: payload.event.item.creation_date,
      start_date: payload.event.item.start_date,
      end_date: payload.event.item.end_date,
      origin: payload.event.item.is_travel
        ? payload.event.item.origin
        : undefined,
      destination: payload.event.item.is_travel
        ? payload.event.item.destination
        : undefined,
      status: payload.event.item.status,
      // advance: payload.event.item.has_advance,
      advance: payload.event.item.totalAmount,
      is_petty_cash: payload.event.item.is_petty_cash,
      // amount_advance: payload.event.item.advance,
      amount_advance: payload.event.item.totalAmount,
      assigned_user_id: payload.event.item.assigned_user_id
        ? payload.event.item.assigned_user_id
        : undefined,
      categories: JSON.parse(JSON.stringify(payload.event.item.categories)),
      validators: JSON.parse(JSON.stringify(payload.event.item.validators)),
      // fuelRequests: payload.event.item.is_vehicle
      //   ? payload.event.item.fuelRequests
      //   : [],
      fuelRequests: payload.event.item.fuelRequests[0]
        ? [payload.event.item.fuelRequests[0]]
        : []
    }

    if (params.fuelRequests.length > 0 && !params.fuelRequests[0].description) {
      delete params.fuelRequests[0].description
    }

    if (payload.event.item.has_advance === 'caja_chica') {
      params.is_petty_cash = 1
      params.advance = false
      params.amount_advance = 0
    }

    if (payload.event.item.has_advance === 'anticipo') {
      params.is_petty_cash = 0
      params.advance = true
    }

    if (payload.event.item.has_advance === 'reembolso') {
      params.is_petty_cash = 0
      params.advance = false
      params.amount_advance = 0
    }

    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {}).then(
      response => {
        commit('onPut', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  reject_request({ commit, dispatch }, payload) {
    let url = 'api/update-status-request/' + payload.event.expensesRequest
    let params = {
      status: payload.event.status,
      comment: payload.event.comment,
      advance: 0
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {}).then(
      response => {
        commit('onPut', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
    // }
  },
  validate_request({ commit, dispatch }, payload) {
    let url = 'api/update-status-request/' + payload.event.expensesRequest
    let params = {
      status: payload.event.status,
      comment: payload.event.comment !== '' ? payload.event.comment : undefined,
      amount_authorized: payload.event.amount_authorized
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {}).then(
      response => {
        commit('onPut', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
    // }
  },
  sendRequest({ commit, dispatch }, payload) {
    let url =
      'api/travel-expenses-request/do-validation-process/' +
      payload.event.expensesRequest
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, {}, {}).then(
      response => {
        commit('onPut', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
    // }
  },
  deleteRequest({ commit, dispatch }, payload) {
    let url = 'api/travel-expenses-request/' + payload.event.expensesRequestD
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {}).then(
      response => {
        commit('onDelete', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
    // }
  },
  async deleteRequestRejected({ commit, dispatch }, payload) {
    const url = `api/expenses-items-back/${payload.event.expensesRequestD}`
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    try {
      const response = await httpgst.delete(url, {}, {})
      commit('onDelete', { event: payload.event, response: response })
    } catch (error) {
      commit('onError', { event: payload.event, error: error })
    }
  },
  delete({ commit, dispatch }, payload) {
    let url = 'api/expenses/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {}).then(
      response => {
        commit('onDelete', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  startWorkflow({ commit, dispatch }, payload) {
    let url = 'api/startWorkFlow/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, {}, {}).then(
      response => {
        commit('onStartWorkflow', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getCategories({ commit, dispatch }, payload) {
    let url = 'api/categories'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetCategories', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getHistory({ commit, dispatch }, payload) {
    let url = `api/expense-progress/${payload.event.id}`
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetHistory', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getExpensesValidators({ commit, dispatch }, payload) {
    let url = `api/expenses-validators/${payload.event.id}`
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetExpensesValidators', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getAcuse({ commit, dispatch }, payload) {
    let url = `api/report-acuse/${payload.event.id}`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetAcuse', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getWorkflowValidatorApprover({ commit, dispatch }, payload) {
    let url = `api/workflow-validator-approver/${payload.event.user_id}`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetWorkflowValidatorApprover', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  }
}

// mutations
const mutations = {
  // Set the data obtained from the expenses endpoint
  onGet(state, payload) {
    payload.event.context.viatics = payload.response.data.data
    if (payload.event.context.actionsLoading) {
      payload.event.context.actionsLoading = false
    }
    payload.event.context.loadingItemsReservations = false
  },
  onDownloadRequest(state, payload) {
    payload.event.context.forceFileDownload(
      payload.response.data,
      'Request-' + payload.event.item.folio + `.${payload.type}`
    )
    payload.event.context.loadingDownload = null
  },
  // Set the data obtained from the expenses endpoint and apply user_id filter
  onGetFiltered(state, payload) {
    let expenses = payload.response.data.data
    expenses.forEach(element => {
      element.amount = 0
      element.gst_expenses_items.forEach(elements => {
        element.amount = parseFloat(elements.total_mxn) + element.amount
      })
    })
    payload.event.context.expenses = expenses
    payload.event.context.loadingItems = false
    // payload.event.context.expensesFilter()
  },
  onGetExpensesOpen(state, payload) {
    let expenses = payload.response.data.data
    expenses.forEach(element => {
      element.amount = 0
      element.gst_expenses_items.forEach(elements => {
        element.amount = parseFloat(elements.total_mxn) + element.amount
      })
    })
    payload.event.context.expensesOpen = expenses
    payload.event.context.loadingItems = false
    // payload.event.context.expensesFilter()
  },
  // Set the data obtained from the expenses endpoint when there is a matching id
  onGetById(state, payload) {
    payload.event.context.expense = payload.response.data.data
  },
  // Add the data from the new expense to the expenses list
  onPost(state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.loading = false
    if(payload.event.context.component === 'viaticRequest') {
      payload.event.context.editedItem.id = payload.response.data.data.id
    } else {
      payload.event.context.editedItemRequest.id = payload.response.data.data.id
    }
    if(payload.event.context.filesId.length > 0 ) return payload.event.context.addFiles()
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onRefresh(state, payload){
    payload.event.context.close()
    payload.event.context.refresh()
  },
  // Updates the data displayed for the modified expense
  onPut(state, payload) {
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    if(payload.event.context.filesId.length > 0 ) return payload.event.context.addFiles()
    payload.event.context.close()
    payload.event.context.refresh()
  },
  // Removes the data of the deleted expense from the expenses list
  onDelete(state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onStartWorkflow(state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeWorkflowDialog()
    payload.event.context.refresh()
  },
  // Set the data obtained from the categories endpoint
  onGetCategories(state, payload) {
    let categories = payload.response.data.data
    payload.event.context.categories = categories
  },
  onGetHistory(state, payload) {
    payload.event.context.histItem.progress = payload.response.data.data
    payload.event.context.filterHistory()
    payload.event.context.histLoading = false.data
  },
  onGetExpensesValidators(state, payload) {
    let expense = payload.response.data.data
    payload.event.context.validatorsExpenses = expense.workflow
  },
  onGetAcuse(state, payload) {
    const byteCharacters = atob(payload.response.data.data.file)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    payload.event.context.forceFileDownload(
      byteArray,
      'Acuse' + `_${new Date().toISOString().substr(0, 10)}.pdf`
    )
  },
  // Shows a error message
  onError(state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    payload.event.context.showNotification(payload.error.response, 'error', -1)

    if(payload.error.response.status === 400) {
      mutations.onDownloadError400(payload.error.response, payload)
    }
      
    payload.event.context.loadingDownload = false
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
    if (payload.event.context.actionsLoading) {
      payload.event.context.actionsLoading = false
    }
  },
  onDownloadError400(errorResponse, payload){
      if (errorResponse) {
        if (errorResponse.data instanceof Blob) {
          const reader = new FileReader()
          reader.onload = () => {
            const errorText = reader.result
            try {
              const errorData = JSON.parse(errorText)
              payload.event.context.showNotification(errorData.message || payload.event.context.$t('validation.error'), 'error', -1)
            } catch (e) {
              payload.event.context.showNotification(errorText, 'error', -1)
            }
          }
          reader.readAsText(errorResponse.data)
        } else {
          payload.event.context.showNotification(errorResponse.data.message || payload.event.context.$t('validation.error'), 'error', -1)
        }
      } else {
        payload.event.context.showNotification(payload.event.context.$t('validation.error'), 'error', -1)
      }
  },
  onDownloadError(state, payload) {
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loadingDownload = null
  },
  onErrorById(state, payload) {
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    setTimeout(function() {
      router.push('/dashboard')
    }, payload.event.context.timeout)
  },
  onGetLogged(state, payload) {
    let userLogged = payload.response.data.data
    payload.event.context.userLogged = userLogged
  },
  onGetWorkflowValidatorApprover(state, payload) {
    let validators = []
    let approvers = []
    let counter = 0
    const responseValidatorsApprovers = Object.assign(
      {},
      payload.response.data.data
    )
    const listValidatorsApprovers = Object.getOwnPropertyNames(
      responseValidatorsApprovers
    )
    listValidatorsApprovers.forEach(i => {
      let el = responseValidatorsApprovers[i]
      el = {
        ...el
      }
      if (el.id) {
        counter++
        el.validatorId = counter
        validators.push(el)
      } else {
        approvers.push(el)
      }
    })

    const orderValidators = list => {
      let counter = 0
      let newList = []
      let first = list.find(x => x.is_first_step === 1)
      if (first !== undefined) {
        counter++
        first.validatorId = counter
        newList.push(first)
        let next = first.next_step
        list.forEach(i => {
          let newNext = list.find(x => x.id === next)
          if (newNext !== undefined) {
            counter++
            newNext.validatorId = counter
            newList.push(newNext)
            next = newNext.next_step
          }
        })
      }
      return newList
    }
    payload.event.context.validators = orderValidators(validators)
    payload.event.context.approvers = approvers
    payload.event.context.workflowName = payload.response.data.data[0].area.name
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/viatics.js